import { Types } from "../actions/AutonomousMaintenanceOrderTasksActions";

const initialState = {
    tasklist: null,
    statusList: null,
    autonomousMaintainanceList: null,
    technicianList: null,
    costCenterList: null,
    mainListByAreaId: null,
    subListByAreaId: null,
    areaList: null,
    error: null,
};

export const AutonomousMaintenanceOrderTaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                tasklist: action.payload.resultObject,
            };

        case Types.SET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                statusList: action.payload.resultObject,
            };
        case Types.SET_MAINTATENANCE_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                autonomousMaintainanceList: action.payload.resultObject,
            };

        case Types.SET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                areaList: action.payload.resultObject,
            };

        case Types.SET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                technicianList: action.payload,
            };

        case Types.SET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS: {
            return {
                ...state,
                costCenterList: action.payload.resultObject,
            };
        }
        case Types.SET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                mainListByAreaId: action.payload.resultObject,
            };
        case Types.SET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                subListByAreaId: action.payload.resultObject,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };

        case Types.RESET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                tasklist: null,
            };
        case Types.RESET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                statusList: null,
            };
        case Types.RESET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                costCenterList: null,
            };
        case Types.RESET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                areaList: null,
            };
        case Types.RESET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                technicianList: null,
            };
        case Types.RESET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                mainListByAreaId: null,
            };
        case Types.RESET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS:
            return {
                ...state,
                subListByAreaId: null,
            };
        case Types.RESET_FILTER:
            return {
                ...state,
                costCenterList: null,
                technicianList: null,
                areaList: null,
                mainListByAreaId: null,
                subListByAreaId: null,
            };
        default:
            return state;
    }
};
